import { mapPersonalInfoType, PersonalInfoType } from "../PersonalInfoType";
import { mapUserRoleInfoType, UserRoleInfoType } from "../UserRoleInfoType";

/* ******************************************************* Attendance staff view */
export interface AttendanceStaffView {
    month?: string;
    month_format?: string;
    dates?: string[];
    colour_dates?: DateColor[];
    project_wise_data?: ProjectWiseData[];
    personal_info_id?: number;
    total_hours?: number;
    total_days?: number;
    total_wage?: number;
    total_paid?: number;
    cumulative?: number;
    payed_data_list?: StaffPaidData[];
    other_expense_list?: OtherExpenseData[];
    personalInfo?: PersonalInfoType | null;
    userRoleInfo?: UserRoleInfoType | null;
}

export const mapAttendanceStaffView = (staffData: any): AttendanceStaffView => {
    if (!staffData) {
        throw new Error('Invalid Data')
    }

    const response: AttendanceStaffView = {
        month: staffData.month,
        month_format: staffData.month_format,
        dates: Array.isArray(staffData.dates) ? staffData.dates : [],
        colour_dates: Array.isArray(staffData.colour_dates) ? mapDateColors(staffData.colour_dates) : [],
        project_wise_data: Array.isArray(staffData.project_wise_data) ? mapProjectWiseDatas(staffData.project_wise_data) : [],
        personal_info_id: staffData.personal_info_id,
        total_hours: staffData.total_hours,
        total_days: staffData.total_days,
        total_wage: staffData.total_wage,
        total_paid: staffData.total_paid,
        cumulative: staffData.cumulative,
        payed_data_list: Array.isArray(staffData.payed_data_list) ? mapStaffPaidDatas(staffData.payed_data_list) : [],
        other_expense_list: Array.isArray(staffData.other_expense_list) ? mapOtherExpenseDatas(staffData.other_expense_list) : [],
        personalInfo: staffData.personalInfo !== null ? mapPersonalInfoType(staffData.personalInfo) : null,
        userRoleInfo: staffData.userRoleInfo !== null ? mapUserRoleInfoType(staffData.userRoleInfo) : null
    }

    return response;
}

export const mapAttendanceStaffViews = (data: any[]): AttendanceStaffView[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapAttendanceStaffView);
}
/* ******************************************************* */


/* ******************************************************* Attendance staff paid data */
export interface StaffPaidData {
    id: number;
    personal_info_id: number;
    date: string;
    payed_amount: number;
    expense_id: number;
}

export const mapStaffPaidData = (data: any): StaffPaidData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: StaffPaidData = {
        id: data.id,
        personal_info_id: data.personal_info_id,
        date: data.date,
        payed_amount: data.payed_amount,
        expense_id: data.expense_id
    }

    return response;
}

export const mapStaffPaidDatas = (data: any[]): StaffPaidData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapStaffPaidData);
}
/* ******************************************************* */


/* ******************************************************* Attendance other expense data */
export interface OtherExpenseData {
    id: number;
    expense_name?: string;
    total_amount?: number;
    list?: StaffPaidData[];
}

export const mapOtherExpenseData = (data: any): OtherExpenseData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: OtherExpenseData = {
        id: data.id,
        expense_name: data.expense_name,
        total_amount: data.total_amount,
        list: Array.isArray(data.list) ? mapStaffPaidDatas(data.list) : []
    }

    return response;
}

export const mapOtherExpenseDatas = (data: any[]): OtherExpenseData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapOtherExpenseData);
}
/* ******************************************************* */


/* ******************************************************* Attendance date color */
export interface DateColor {
    date?: string;
    colour_code?: string;
}

export const mapDateColor = (data: any): DateColor => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: DateColor = {
        date: data.date,
        colour_code: data.colour_code
    }

    return response;
}

export const mapDateColors = (data: any[]): DateColor[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapDateColor);
}
/* ******************************************************* */


/* ******************************************************* Attendance project wise data */
export interface ProjectWiseData {
    project_id?: number;
    colour_code?: string;
    project_data?: ProjectData | null;
    count?: number;
    dates?: string[];
}

export const mapProjectWiseData = (data: any): ProjectWiseData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: ProjectWiseData = {
        project_id: data.project_id,
        colour_code: data.colour_code,
        project_data: data.project_data !== null ? mapProjectData(data.project_data) : null,
        count: data.count,
        dates: Array.isArray(data.dates) ? data.dates : [],
    }

    return response;
}

export const mapProjectWiseDatas = (data: any[]): ProjectWiseData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapProjectWiseData);
}
/* ******************************************************* */


/* ******************************************************* Attendance project wise data */
export interface ProjectData {
    project_id?: number;
    job_number?: string;
    project_type?: string;
    description?: string | null;
    status?: string;
    user_id?: number;
    address?: string | null;
    post_code?: string | null;
    full_address?: string | null;
}

export const mapProjectData = (data: any): ProjectData => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const response: ProjectData = {
        project_id: data.project_id,
        job_number: data.job_number,
        project_type: data.project_type,
        description: data.description ?? null,
        status: data.status,
        user_id: data.user_id,
        address: data.address ?? null,
        post_code: data.post_code ?? null,
        full_address: data.full_address ?? null,
    }

    return response;
}

export const mapProjectDatas = (data: any[]): ProjectData[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapProjectData);
}
/* ******************************************************* */